__turbopack_context__.v({
  "className": "ibm_plex_sans_arabic_94c7303f-module__GMamVa__className",
});
